import { Component, inject } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { routes } from 'src/routes';
import { PagesV2Module } from '@schenck/rotec-components';
import { TranslateDirective } from '@ngx-translate/core';

/**
 * Navigation component.
 */
@Component({
  selector: 'um-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.less'],
  imports: [PagesV2Module, RouterLinkActive, RouterLink, TranslateDirective],
})
export class PagesComponent {
  private readonly router = inject(Router);

  public userListUrl = routes.userList.absoluteUrl;

  public get isActive(): boolean {
    return this.router?.url === this.userListUrl;
  }
}
